<template>
  <div class="tabs_content">
    <VodVideosListComponent></VodVideosListComponent>
  </div>
</template>

<script>
import localTable from "@/components/mixins/local-table"
import VodVideosListComponent from "../../vodVideos/VodVideosListComponent.vue";

export default {
  name: "Videos",
  components: {VodVideosListComponent},
  mixins: [localTable],
  props: {
    entity: Object
  },
  data(){
    return {
      tabName: "videos",
    }
  },
  computed: {
    entities(){
      return this.entity.videos;
    },
    csvHeaders(){
      return {
        'name': {name: this.$gettext('Název')},
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodProviders/detail/Videos.vue